import React from 'react'

import { normalizeLabel } from '../../../utils/normalizeLabel'
import * as S from './AnalyticsDataLabel.styled'

type AnalyticsDataLabelProps = {
  label: string
  icon?: {
    src?: string
    width?: number
    aspectRatio?: number
  }
  shouldNormalizeLabel?: boolean
  description?: string
}

export const AnalyticsDataLabel = ({
  label,
  shouldNormalizeLabel = true,
  icon,
  description,
}: AnalyticsDataLabelProps) => (
  <S.Container>
    <S.Main>
      {icon?.src && (
        <S.Icon width={icon.width || 20} aspectRatio={icon.aspectRatio}>
          <img src={icon.src} alt={label} />
        </S.Icon>
      )}
      {shouldNormalizeLabel ? normalizeLabel(label) : label}
    </S.Main>
    {description && <S.Description>{description}</S.Description>}
  </S.Container>
)
